import React from 'react';
import PropTypes from 'prop-types';
import { Backdrop, Fade, Modal } from '@material-ui/core';

/* Modal padrão para visualização de imagens */
const ImagePreviewModal = ({
    alt,
    imageStyle,
    onClose,
    open,
    src
}) => (
    <Modal
        open={open}
        onClose={onClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{ timeout: 500 }}
    >
        <Fade in={open}>
            <div
                style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: '90vw',
                    height: '85vh',
                    maxWidth: 1040,
                    maxHeight: 585,
                    backgroundColor: 'transparent',
                    borderRadius: 12,
                    boxShadow: 'none',
                    border: 'none',
                    outline: 'none',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: 0
                }}
            >
                {src && (
                    <img
                        src={src}
                        alt={alt}
                        style={{
                            maxWidth: '100%',
                            maxHeight: '100%',
                            borderRadius: 8,
                            objectFit: 'contain',
                            ...imageStyle
                        }}
                    />
                )}
            </div>
        </Fade>
    </Modal>
);

ImagePreviewModal.propTypes = {
    alt: PropTypes.string,
    imageStyle: PropTypes.object,
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    src: PropTypes.string
};

ImagePreviewModal.defaultProps = {
    alt: 'Imagem',
    imageStyle: {},
    src: ''
};

export default ImagePreviewModal;